import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Alert } from '@leapeasy/ui-kit';
import { Box } from '@mui/material';
import { successNotif, failedNotif } from 'store/actions/notifActions';
import { useNotificationMessages } from 'hooks/useNotificationMessages';

export const AppNotification = () => {
  const dispatch = useDispatch();
  const { successText, failedText, hasSuccess, hasError } = useNotificationMessages();

  const isOpen = hasSuccess || hasError;
  const description = hasSuccess ? successText : failedText;

  const handleClose = useCallback(() => {
    dispatch(successNotif(null));
    dispatch(failedNotif(null));
  }, [dispatch]);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }
    const timer = setTimeout(handleClose, 5000);
    return () => clearTimeout(timer);
  }, [isOpen, description, handleClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: { xs: 16, md: 24 },
        right: { xs: 16, md: 24 },
        zIndex: 2000,
        width: '100%',
        maxWidth: 420,
        pointerEvents: 'none',
        '& > *': { pointerEvents: 'auto' },
      }}
    >
      <Alert
        type={hasSuccess ? 'success' : 'error'}
        variant="contained"
        showBorder
        showIcon
        description={description}
        showClose
        onClose={handleClose}
      />
    </Box>
  );
};
